import { render, staticRenderFns } from "./AppVersions.vue?vue&type=template&id=4ed90830&scoped=true"
import script from "./AppVersions.vue?vue&type=script&lang=js"
export * from "./AppVersions.vue?vue&type=script&lang=js"
import style0 from "./AppVersions.vue?vue&type=style&index=0&id=4ed90830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed90830",
  null
  
)

export default component.exports